import { useCallback, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { Layout } from "../../../../../shared/components/Layout";
import { FlowAddFundingMethod } from "../../../components/funding/FlowAddFundingMethod";
import {
  PATH_SETTINGS_PAYROLL_ADD_FUNDING_METHOD,
  PATH_SETTINGS_PAYROLL_METHOD
} from "../../../paths";

export const RouteAddFundingMethod: React.FC = () => {
  const history = useHistory();
  const location = useLocation<{ backPath?: string }>();

  const [backPath] = useState(
    location.state?.backPath || PATH_SETTINGS_PAYROLL_METHOD
  );

  const onBack = useCallback(() => {
    history.push(backPath);
  }, [backPath, history]);

  return (
    <Layout
      title="Add payroll funding method"
      onClose={onBack}
      showFooterAdditionalInfo
    >
      <FlowAddFundingMethod
        basePath={PATH_SETTINGS_PAYROLL_ADD_FUNDING_METHOD}
        onBack={onBack}
        onNext={onBack}
      />
    </Layout>
  );
};
